import { render, staticRenderFns } from "./SetHeight.vue?vue&type=template&id=6aa33385&scoped=true&"
import script from "./SetHeight.vue?vue&type=script&lang=js&"
export * from "./SetHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa33385",
  null
  
)

export default component.exports